/**
 * Human Resources Module
 *
 * This module provides HR management functionality including:
 * - Employee management (Zaposleni) - Create, update, archive, link to user
 * - Organizational structure (Organizaciona struktura) - Work units (Sector / Department / Team / Office)
 */

import type { ModuleDefinition } from '@core/router/types';
import { humanResourcesRoutes } from './routes';
import { humanResourcesNavigation, humanResourcesModuleInfo } from './navigation';

/**
 * Human Resources Module Definition
 */
export const humanResourcesModule: ModuleDefinition = {
  name: 'ljudski-resursi',
  basePath: '/ljudski-resursi',
  routes: humanResourcesRoutes,
  navigation: humanResourcesNavigation,
  moduleInfo: humanResourcesModuleInfo,
};

export default humanResourcesModule;
